<template>
    <div class="flex flex-wrap flex-seize">
        <div v-if="limit" class="flex--order-2 spacer-10">
            <a href="javascript: void(0);" class="pointer" @click="toggleMoreLess(!showMoreLess)" :aria-controls="containerId" :aria-expanded="showMoreLess" role="button" :aria-label="button.label">
                <i class="material-icons" aria-hidden="true" role="img">{{button.icon}}</i> {{button.text}}
            </a>
        </div>

        <div ref="container" v-bind="containerAttributes" role="region" :class="[{'show-more-container-limiter': !showMoreLess, fade}, 'flex--order-1 spacer-10']">
            <slot/>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator';

    @Component({
        name: 'MoreLessContainer',
    })
    export default class MoreLessContainer extends Vue
    {
        readonly $refs: {
            container: HTMLElement,
        };

        @Prop({
            type: Number,
            default: 100,
            required: false,
        }) maxHeight: number;

        @Prop({
            type: Boolean,
            default: true,
            required: false,
        }) fade: boolean;

        @Prop({
            type: String,
            default: 'Mehr anzeigen',
            required: false,
        }) moreText: string;

        @Prop({
            type: String,
            default: 'Weniger anzeigen',
            required: false,
        }) lessText: string;

        limit = false;

        showMoreLess = true;

        get containerAttributes()
        {
            return {
                id: this.containerId,
                style: this.showMoreLess ? '' : 'max-height: ' + this.maxHeight + 'px',
                tabindex: this.limit ? 0 : null,
                'aria-hidden': !this.showMoreLess,
            };
        }

        get containerId()
        {
            return 'more-less-' + this._uid;
        }

        get button()
        {
            if (this.showMoreLess)
            {
                return {
                    label: 'Inhalt verbergen',
                    text: this.lessText,
                    icon: 'keyboard_arrow_up',
                };
            }

            return {
                label: 'Inhalt anzeigen',
                text: this.moreText,
                icon: 'keyboard_arrow_down',
            };
        }

        @Watch('maxHeight')
        watchMaxHeight()
        {
            this.update();
        }

        mounted()
        {
            this.update();
        }

        update()
        {
            this.limit = this.maxHeight < this.$el.clientHeight;
            this.showMoreLess = !this.limit;
        }

        toggleMoreLess(show: boolean): void
        {
            this.showMoreLess = show;

            if (show)
            {
                this.$nextTick(() => {
                    this.$refs.container.focus();
                })
            }
        }
    };
</script>